export function getAllTradeProvisions(axiosPrivate) {
  return axiosPrivate.get('/trade-provisions')
}

export function getTradeProvisionById(axiosPrivate, id) {
  return axiosPrivate.get(`/trade-provisions/${id}`)
}

export function createTradeProvision(axiosPrivate, data) {
  return axiosPrivate.post('/trade-provisions', data)
}

export function updateTradeProvisionById(axiosPrivate, id, data) {
  return axiosPrivate.put(`/trade-provisions/${id}`, data)
}

export function deleteTradeProvision(axiosPrivate, id) {
  return axiosPrivate.delete(`/trade-provisions/${id}`)
}
